import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'

import { api } from '../adminApi'


export default /*#__PURE__*/_defineComponent({
  __name: 'StoreList',
  setup(__props) {


const stores = ref([] as string[])

async function fetch() {

  try {
    const response = await api.getStores()
    stores.value = response.data
  } catch (error) {
    console.log(error)
  }
}

fetch()


return { __sfc: true,stores, fetch }
}

})